import BaseApiRequest from "./BaseApiRequest";
import { VAULT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetVaultRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  url = VAULT_URL;

  body = {};

  constructor(request) {
    super();

    if (request.vaultUrl) {
      this.url = VAULT_URL + request.vaultUrl;
    } else {
      throw new Error("Vault Url is required");
    }
  }
  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
